/**
 * Heart particles (vanilla `heart`): animals in love mode puff one every 10
 * ticks; it floats up and fades. Small self-contained sprite pool using the
 * real heart.png sprite, so it needs no particle atlas slot.
 */

import * as THREE from 'three';

const POOL = 48;
const LIFE = 1.0;

/** Real vanilla particle sprite (heart.png; happy_villager is the green glint.png). */
function particleTexture(name: string): THREE.Texture {
  const t = new THREE.TextureLoader().load(`mc/particle/${name}.png`);
  t.magFilter = THREE.NearestFilter; t.minFilter = THREE.NearestFilter; t.colorSpace = THREE.SRGBColorSpace;
  return t;
}

export class Hearts {
  readonly group = new THREE.Group();
  private readonly sprites: { s: THREE.Sprite; life: number; vy: number }[] = [];
  private next = 0;

  private readonly heartMat: THREE.SpriteMaterial;
  private readonly happyMat: THREE.SpriteMaterial;

  constructor() {
    const mat = new THREE.SpriteMaterial({ map: particleTexture('heart'), transparent: true, depthWrite: false });
    this.heartMat = mat;
    this.happyMat = new THREE.SpriteMaterial({ map: particleTexture('glint'), transparent: true, depthWrite: false });
    for (let i = 0; i < POOL; i++) {
      const s = new THREE.Sprite(mat.clone());
      s.scale.setScalar(0.25);
      s.visible = false;
      this.group.add(s);
      this.sprites.push({ s, life: 0, vy: 0 });
    }
  }

  spawn(x: number, y: number, z: number, kind: 'heart' | 'happy' = 'heart'): void {
    const p = this.sprites[this.next];
    (p.s.material as THREE.SpriteMaterial).map = (kind === 'heart' ? this.heartMat : this.happyMat).map;
    p.s.scale.setScalar(kind === 'heart' ? 0.25 : 0.15);
    this.next = (this.next + 1) % POOL;
    p.s.position.set(x, y, z);
    p.s.visible = true;
    p.life = LIFE;
    p.vy = kind === 'heart' ? 0.4 + Math.random() * 0.2 : 0.1;
  }

  update(dt: number): void {
    for (const p of this.sprites) {
      if (p.life <= 0) continue;
      p.life -= dt;
      if (p.life <= 0) { p.s.visible = false; continue; }
      p.s.position.y += p.vy * dt;
      (p.s.material as THREE.SpriteMaterial).opacity = Math.min(1, p.life * 3);
    }
  }
}
